import { useMemo } from 'react';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';

import { SPLIT_API_KEY_DEV, SPLIT_API_KEY_PROD, SPLIT_API_KEY_STAGING } from 'constants/publicKeys';
import useGlobalStore from 'hooks/useGlobalStore';
import { getIsProduction, getIsStaging } from 'utils';

function SplitProvider({ children }) {
    const { splitKey } = useGlobalStore();

    let authorizationKey;

    if (getIsProduction()) {
        authorizationKey = SPLIT_API_KEY_PROD;
    } else if (getIsStaging()) {
        authorizationKey = SPLIT_API_KEY_STAGING;
    } else {
        authorizationKey = SPLIT_API_KEY_DEV;
    }

    const splitSdkConfig = useMemo(
        () => ({
            core: {
                authorizationKey,
                key: splitKey,
            },
        }),
        [splitKey]
    );

    return (
        <SplitFactoryProvider config={splitSdkConfig} updateOnSdkTimedout>
            {children}
        </SplitFactoryProvider>
    );
}

export default SplitProvider;
